export var NUANCE_SET_LOADED = 'NUANCE_SET_LOADED';
export var NUANCE_SET_UNLOADED = 'NUANCE_SET_UNLOADED';
export var AUXI_WEBSDK_LOADED = 'AUXI_WEBSDK_LOADED';
export var loadNuance = function loadNuance() {
  return {
    type: NUANCE_SET_LOADED
  };
};
export var unloadNuance = function unloadNuance() {
  return {
    type: NUANCE_SET_UNLOADED
  };
};
export var loadAuxiWebsdk = function loadAuxiWebsdk() {
  return {
    type: AUXI_WEBSDK_LOADED
  };
};